import { z } from 'zod';

export const NotificationCellSchema = z.object({
  type: z.string(),
  data: z.any()
});
